import { EntityRequestTmppay } from "../../entity/EntityRequestTmppay";

export class DtoRequestTmppaysDeleteRes extends EntityRequestTmppay {
  public message: string | null = null;
}
